const resources = {
    greeting: 'Hi',
    signIn: 'Sign In',
    signInPrompt: 'for FREE Shipping',
    biHeading: 'Beauty Insider Summary',
    biDesc: 'View activity, savings, benefits',
    rewardsHeading: 'Rewards Bazaar',
    rewardsDesc: 'Redeem items, samples, more',
    pointsLabel: 'Point',
    chooseBirthdayGift: 'Choose your Birthday gift!',
    ccHeading: 'Sephora Credit Card Program',
    ccDesc: 'View and manage credit card and rewards',
    ccRewardsLabel: 'Rewards',
    ccApplyNow: 'Apply now',
    ordersHeading: 'Purchase History',
    ordersDesc: 'View & track online or pickup orders',
    autoReplenishHeading: 'Auto-Replenish',
    autoReplenishDescWithSubs: 'View and manage your subscriptions',
    autoReplenishDesc: 'Never run out of your go-tos with subscription delivery',
    purchasesHeading: 'Buy It Again',
    purchasesDesc: 'Reorder from in-store and online purchases',
    lovesHeading: 'Loves',
    myListsHeading: 'My Lists',
    lovesDesc: 'View saved products',
    myListsDesc: 'Organize and share saved products',
    communityHeading: 'Community',
    communityDesc: 'Get inspired by fellow beauty lovers',
    recHeading: 'Beauty Advisor Recommendations',
    recDesc: 'Recommendations from your store visits',
    reservationsHeading: 'Reservations',
    reservationsDesc: 'Manage your services and events',
    beautyPrefHeading: 'Beauty Preferences',
    beautyPrefDesc: 'Complete to see your personalized recommendations',
    guidedSellingBeautyPrefDesc: 'Complete for personalized recommendations and filters',
    accountHeading: 'Account Settings',
    accountDesc: 'Payment, contact info, addresses, password',
    signOut: 'Sign Out',
    sameDayUnlimitedHeading: 'Same-Day Unlimited',
    sameDayUnlimitedMemberDesc: 'Manage your subscription',
    sameDayUnlimitedNonMemberDesc: 'Get Unlimited Free Same-Day Delivery',
    subscribeToday: 'Subscribe today',
    beautyChallenges: 'Beauty Insider Challenges',
    new: 'NEW',
    galleryHeading: 'Gallery',
    galleryDesc: 'Add photos and get inspired by others',
    beautyChallengesDescription: 'Earn points when you complete tasks',
    purchasesViewAll: 'View all',
    rewardsAndBenefitsHeading: 'Rewards & Benefits',
    rewardsAndBenefitsDesc: 'Learn more about our loyalty program',
    or: 'or',
    join: 'Join'
};

export default function getResource(label) {
    return resources[label];
}
